import { useState } from "react";
import EditIcon from "../../icons/edit.svg";
import { clsx } from "clsx";
import EditMainClaim from "./EditMainClaim";

function MainClaim(props) {
	const [editingMainClaim, setEditingMainClaim] = useState(false);

	const convincedVotes = props.mainClaim.convinced.length;
	const notPersuadedVotes = props.mainClaim.notPersuaded.length;

	const convincedPercentage =
		convincedVotes !== 0
			? Math.round((convincedVotes / (convincedVotes + notPersuadedVotes)) * 100)
			: 0;
	const notPersuadedPercentage =
		notPersuadedVotes !== 0
			? Math.floor((notPersuadedVotes / (notPersuadedVotes + convincedVotes)) * 100)
			: 0;

	const isVotingEnabled = props.mainClaim.phase === "strawpoll" || props.mainClaim.phase === "endpoll";

	const didVoteConvinced = props.mainClaim.convinced.includes(props.player.id);
	const didVoteNotPersuaded = props.mainClaim.notPersuaded.includes(props.player.id);

	// TODO: Centralise Phase Changes Buttons

	const style = {
		select:
			"py-1 block text-center text-gray-700 bg-white border-[2px] border-sky-500 rounded-md focus:border-[3px] focus:border-sky-500",
		button: "py-1.5 px-5 rounded font-bold text-white",
		// phasesContainer: "w-[30em] h-[6em] p-0 m-0 flex flex-col justify-around items-center",
		phasesBar: "w-96 h-[1.8em] flex justify-between items-center border-2 border-black-200 rounded-full",
		phasesCircle: "w-[1.7em] h-full border-2 border-green-400 rounded-full",
		phaseActive: "bg-green-400",
		phaseInactive: "border-green-400 bg-green-50",
		// phaseButtonContainer: "w-[80%] h-[30%] flex justify-center gap-x-4",
		phaseButton: "w-[30%] px-2 py-1 font-bold px-4 text-sm text-slate-50 rounded-full",
		endpollBtn: "m-auto py-1.5 px-5 rounded font-bold text-white bg-indigo-400 hover:bg-indigo-500 cursor-pointer",
		zIndex: "z-2"
	};

	function switchEditing() {
		setEditingMainClaim(!editingMainClaim);
	}
	
	function updateMainClaim(editedMainClaim) {
		props.handleUpdateMainClaim(editedMainClaim);
		switchEditing();
	}

	function moveToPreviousPhase() {
		let index = getCurrentPhaseIndex();
		if (index > 0) {
			index--;
			const phaseValue = props.phases.at(index).value;
			props.handleChangeGamePhase(phaseValue);
		}
	}

	function moveToNextPhase() {
		let index = getCurrentPhaseIndex();
		if (index < props.phases.length - 1) {
			index++;
			const phaseValue = props.phases.at(index).value;
			props.handleChangeGamePhase(phaseValue);
		}
	}

	function getCurrentPhaseIndex() {
		return props.phases.findIndex(element => element.value === props.mainClaim.phase);
	}

	function isFirstPhase() {
		const index = getCurrentPhaseIndex();
		return index == 0;
	}

	function isLastPhase() {
		const index = getCurrentPhaseIndex();
		return index == props.phases.length - 1;
	}

	function getPreviousPhaseLabel() {
		const index = getCurrentPhaseIndex();
		if (index > 0) {
			return props.phases.at(index - 1).text;
		}
		return "";
	}

	function getCurrentPhaseLabel() {
		const index = getCurrentPhaseIndex();
		return props.phases.at(index).text;
	}

	function getNextPhaseLabel() {
		const index = getCurrentPhaseIndex();
		if (index < props.phases.length - 1) {
			return props.phases.at(index + 1).text;
		}
		return "";
	}

	return (
		<div className={clsx(style.zIndex, "sticky top-0 text-center border rounded-lg shadow-lg pb-2 bg-gray-50")}>
			{editingMainClaim !== true ? (
				<>
					<div>
						{props.mainClaim.phase === "endpoll" ? (
							<div className="p-2 text-2xl shadow-lg border rounded-md font-bold">Final Poll</div>
						) : null}
						<div className="w-[90%] m-auto text-center mt-2 lg:text-2xl text-lg font-semibold text-pure-black">
							<div>
								<span className="lg:inline hidden lg:text-base">MainClaim:</span> {props.mainClaim.mainClaim}
							</div>
						</div>
						{props.role === "referee" ? (
							<div className="flex justify-center mx-auto my-2 w-[22%]">
								<button
									aria-label="Show Results"
									hidden={props.mainClaim.phase !== "endpoll"}
									className={style.endpollBtn}
									onClick={props.handleGetFinalResults}>
									Show Results
								</button>
								
								<button
									aria-label="Download Results"
									hidden={props.mainClaim.phase !== "endpoll"}
									className={style.endpollBtn}
									onClick={props.handleDownloadResults}>
									Download Results
								</button>

								{props.mainClaim.phase !== 'endpoll' ?
									(
										<button
											aria-label="Edit MainClaim"
											className={clsx(style.zIndex, "absolute top-2 right-2 p-1 border-1 border-slate-400 hover:bg-slate-300 rounded-lg cursor-pointer")}
											onClick={switchEditing}>
											<EditIcon className="w-[18px]" />
										</button>
									) : null}
							</div>
						) : null}

						<div className="flex justify-center gap-1">
							<div className="w-[30em] p-0 m-0 flex flex-col justify-around items-center">
								<div className="w-[80%] flex justify-center gap-x-4">
									{props.role === "referee" ? (
										<>
											{isFirstPhase() ? 
												null : 
													(
														<>
															<button
																className={`${style.phaseButton} bg-emerald-500 hover:bg-emerald-600 cursor-pointer`}
																onClick={moveToPreviousPhase}>
																{`< ${getPreviousPhaseLabel()}`}
															</button>
														</>
													)
												}
											<button className={`${style.phaseButton} bg-slate-400`} disabled={true}>
												{getCurrentPhaseLabel()}
											</button>
											{isLastPhase() ? 
												null : 
													(
														<>
															<button
																className={`${style.phaseButton} bg-emerald-500 hover:bg-emerald-600 cursor-pointer`}
																onClick={moveToNextPhase}>
																{`${getNextPhaseLabel()} >`}
															</button>
														</>
													)
												}
										</>
									) : null}
								</div>
							</div>
						</div>
					</div>
				</>
			) : (
				<EditMainClaim mainClaim={props.mainClaim.mainClaim} switchEditing={switchEditing} updateMainClaim={updateMainClaim} />
			)}

			<div className="flex justify-center">
				<div className="flex flex-col pt-1">
					<div className="flex flex-row mb-1 items-center justify-between">
						<div className="text-left mr-2">
							<span className="text-xs lg:font-semibold inline-block text-lighter-blue">
								{convincedPercentage}% Convinced ({convincedVotes}) Votes
							</span>
						</div>
						<div className="text-right ml-2">
							<span className="text-xs lg:font-semibold inline-block text-persuaded-green">
								{notPersuadedPercentage}% Not Persuaded ({notPersuadedVotes}) Votes
							</span>
						</div>
					</div>
					<div
						className={`h-4 w-full mb-2 text-xs flex rounded-lg ${
							notPersuadedPercentage ? "bg-persuaded-green" : "bg-neutral-gray"
						}`}>
						<div
							style={{ width: `${convincedPercentage}%` }}
							className="shadow-none flex flex-col text-center whitespace-nowrap text-white justify-center rounded-lg bg-lighter-blue"></div>
					</div>
				</div>
			</div>

			<div>
				{props.role === "player" ? (
					<div className="flex justify-center gap-9 p-2">
						<button
							className={clsx(style.button,
								isVotingEnabled && "cursor-pointer",
								didVoteConvinced && "bg-gray-600 inset-ring-2 inset-ring-lighter-blue/50",
								!didVoteConvinced && "bg-lighter-blue"
							)}
							disabled={!isVotingEnabled}
							onClick={props.handleConvincedVote}>
							Convinced
						</button>
						<button
							className={clsx(style.button,
								isVotingEnabled && "cursor-pointer",
								didVoteNotPersuaded && "bg-gray-600 inset-ring-2 inset-ring-persuaded-green/50",
								!didVoteNotPersuaded && "bg-persuaded-green"
							)}
							disabled={!isVotingEnabled}
							onClick={props.handleNotPersuadedVote}>
							{props.mainClaim.phase === "endpoll" ? "(Still) Not Persuaded" : "Not Persuaded"}
						</button>
					</div>
				) : null}
			</div>

			{props.player.name ? <span className="lg:text-lg text-base px-4">Player: {props.player.name}</span> : null}
			{
				<span className="lg:text-lg text-base px-4">
					Match Code: <span className="px-1 ring-2 bg-blue-50 select-all rounded">{props.roomCode}</span>{" "}
				</span>
			}
		</div>
	);
}

export default MainClaim;
